import React from 'react';

// Code — custom code snippets/transforms used across the platform (backed by the custom_code table /
// ui-v2-customcode lambda). Placeholder page; functionality TBD.
const CodePage = () => {
    return (
        <div style={{ padding: '2rem', maxWidth: 960 }}>
            <div style={{ marginBottom: '2rem' }}>
                <h1 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#1e293b', margin: '0 0 0.5rem' }}>Code</h1>
                <p style={{ color: '#6b7280', margin: 0 }}>
                    Manage custom code used across integrations and pipelines.
                </p>
            </div>

            <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 10, padding: '1.5rem' }}>
                <div style={{ fontWeight: 600, color: '#111827', marginBottom: '0.5rem' }}>Coming soon</div>
                <p style={{ color: '#6b7280', margin: 0, fontSize: '0.925rem' }}>
                    This page will list and manage custom code snippets.
                </p>
            </div>
        </div>
    );
};

export default CodePage;
